import { render, staticRenderFns } from "./class-list.vue?vue&type=template&id=6b516b2f&scoped=true"
import script from "./class-list.vue?vue&type=script&lang=js"
export * from "./class-list.vue?vue&type=script&lang=js"
import style0 from "./class-list.vue?vue&type=style&index=0&id=6b516b2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b516b2f",
  null
  
)

export default component.exports